import React, { Component } from "react";
import { Button, Image } from "react-bootstrap";
import { get } from "lodash";
import IconTime from "../../assets/icon-time.svg";
import MOMDesc from "../MOM/MOMDesc";
import AddDecision from "./AddDecision.issueList";
import {
  dayAgo,
  dateFormat,
  formatNumber,
  getColor,
  transformProjectCategoryId,
  projectFormLabel,
  isValidArray,
  getBackgroundColorCode
} from "../../helper";
import { ISSUE_STATUS, PATHS, STATUS } from "../../constant";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DisplayContent } from "../displayContent";
import { Pragati } from "../prgatiReview";
import { Nip } from "../nipReview";
import { Pli } from "../pliReview";
import {
  MultipleTags,
  OrganizationTemplate,
  ReadMore,
  RedirectUser
} from "../reusableComponent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getLocalstorage } from "../../helper";
import { getActions } from "../../actions/issuesListAction.actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import IssueActions from "../issueList/IssueActions";
import { _getIssueList } from "../../actions/issues.action";
import { getMomDetails } from "../../actions/mom.action";
import { shouldDisplayIssueAction } from "../issueList/helper";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
// import { PmgsHipimage } from "../pmgsHipp/pmgsHip";
import { PmgsHipimage } from "../pmgsHipPragati/pmgsHip";
import { March24 } from "../march24";
import { getProjectDetailsforPragti } from "../../services/apiServices";
import request from "../../services/requestService";
import Attachment from "../../assets/quill_attachment.svg";
import { EscalationLevelModal } from "../reusableComponent/EscalationLevel/EscalationLevelModal";
import IssuePragatiReview from "../prgatiReview/IssuePragatiReview";
import { toolttipDisplayMessage } from "../issueList/helper";
import AgendaIssuePragatiReview from "../prgatiReview/AgendaIssuePragatiReview";
import AgendaIssuePragatiPipeline from "../prgatiReview/AgendaIssuePragatiPipeline";
import { PragatiPipeline } from "../prgatiReview/pragatiPipeline";
const MESSAGES_CONSTANT = {
  "Add Decision": "Add decision taken in meeting or by higher authority",
  "Edit Decision": "Edit decision taken in meeting or by higher authority",
  Actions: "Actions"
};

const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

const DRAFT = "DRAFT";
const REJECTED = "Rejected";
const UNDER_CENTRAL_PMG = "under central pmg";
const truncateWithEllipsis = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength - 3) + "..."; // Truncate to maxLength-3 and add "..."
};
const ProjectCard = ({
  project,
  issues,
  agendaData,
  index,
  showOtherPPList,
  onChangePPList
}) => {
  let projectLocations = [];
  if (isValidArray(get(project, "locations"))) {
    // projectLocations = get(project, "locations").map((location, index) =>
    //   index < get(project, "locations").length - 1
    //     ? location.state + ", "
    //     : location.state + ""
    // );
    if (get(project, "category") === "STATE") {
      projectLocations = get(project, "locations")
        .map(location => {
          if (location.districtIdName.length > 0) {
            return location.districtIdName
              .map((district, districtIndex) => {
                return district.name;
              })
              .join(", ");
          } else {
            return "-";
          }
        })
        .join(", ");
    } else {
      projectLocations = get(project, "locations").map((location, index) =>
        index < get(project, "locations").length - 1
          ? location.state + ", "
          : location.state + ""
      );
    }
  }
  const createdBy =
    project.projectPPList && project.projectPPList.length
      ? project.projectPPList[0]
      : null;
  const decisionscreatedBy =
    project.projectDecisions && project.projectDecisions.length
      ? project.projectDecisions[0]
      : null;

  //console.log(project)
  const projectPPList =
    project.projectPPList && project.projectPPList.length
      ? project.projectPPList
      : [];

  function getUniqueOrganizations(data) {
    // Filter out null values before creating the set
    const filteredData = data.filter(item => item.organizationGroup !== null);
    // Create a Set to store unique organization groups
    const uniqueOrgs = new Set(
      filteredData.map(item => item.organizationGroup)
    );
    // Convert the Set back to an array
    return Array.from(uniqueOrgs);
  }
  const uniqueOrganizations = getUniqueOrganizations(projectPPList);
  const upProjectId = get(project, "upProjectId");
  const iigProjectCommonId = get(project, "commonId");
  const projectCost = formatNumber(get(project, "cost", 0));
  const isIIGDraft = "iig draft";
  let meetingOm = get(project, "projectDecisions[0].fileDTOList", []);
  //console.log(meetingOm);
  return (
    <div className="project-issues-pragatidetail">
      <div
        className="project-list-box-wrapper pragati-project-list-box-wrapper"
        data-test="project-list-wrapper"
        style={{
          //clipPath: issues.length == 0 || projectPPList.length<=1&&issues.length>=1 ? null : "inset(0px 0px 0px 0px)",
          borderRadius: issues.length == 0 ? "4px" : null
        }}
      >
        <div class="pragati-select-issue-wrapper agenda-project-wrapper">
          <div class="pragati-project-container">
            <div
              className="project-list-box-top"
              style={{
                borderBottom: 0,
                paddingBottom: 0,
                paddingLeft: 10,
                paddingRight: 10
              }}
            >
              <div className="userprojectcount">#{index + 1}</div>
              <div
                className="project-box-top-upper"
                style={{ marginBottom: 0 }}
              >
                <div className="pragati-project-name-section">
                  <div className="d-flex flex-wrap">
                    <div>
                      {iigProjectCommonId && (
                        <div className="id-wrapper-box mr-2">
                          <p className="border-right mb-1 common-project-id">
                            COMMON PROJECT ID{" "}
                            <b className="link-color mr-2 iig-project-link-color">
                              {this.openProjectPageBasedOnCommonLink()}
                            </b>
                          </p>
                        </div>
                      )}
                      {upProjectId && (
                        <div className="id-wrapper-box mr-2">
                          <p className="border-right mb-1 common-project-id">
                            CMIS PROJECT ID{" "}
                            <b className="link-color mr-2 iig-project-link-color">
                              #{upProjectId}
                            </b>
                          </p>
                        </div>
                      )}
                    </div>
                    <div
                      className="project-id mb-1"
                      style={{ fontFamily: "mpsb", color: "#525252" }}
                    >
                      PROJECT{" "}
                      <b style={{ fontFamily: "mpsb" }}>
                        <Link
                          to={{
                            pathname: PATHS.PROJECT_DETAILS,
                            search: `?projectId=${project.id}`
                          }}
                        >
                          #PMG-
                          {project.id}
                        </Link>
                      </b>
                      {/* <b data-test="project-id">
                      {this.openProjectPageBasedOnLink()}
                    </b> */}
                    </div>
                    {uniqueOrganizations.map((organization, index) => (
                      <OrganizationTemplate
                        key={index}
                        title={organization}
                        classes="pragati-page-organisation mb-2 g"
                      />
                    ))}
                    {/* {projectPPList &&
                      projectPPList.map(item => {
                        if (item !== null) {
                          if (item.organizationGroup !== null) {
                            return (
                              <OrganizationTemplate
                                title={item.organizationGroup}
                                classes="pragati-page-organisation mb-2 g"
                              />
                            );
                          }
                        }
                      })} */}
                    {/* <span class="pragati-page-verified mb-2 g">verified</span> */}
                    {get(project, "status") == null ? null : (
                      <>
                        <div className="project-tags">
                          <div
                            className={`${getBackgroundColorCode(
                              get(project, "status")
                            )} project-stage-background pragati-page-verified mb-2 g`}
                          >
                            <span
                              //class="pragati-page-verified mb-2 g"
                              data-test="project-stage"
                            >
                              {get(project, "status")}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <Link
                    to={{
                      pathname: PATHS.PROJECT_DETAILS,
                      search: `?projectId=${project.id}`
                    }}
                  >
                    <h2 className="pragati-project-heading">{project.name}</h2>
                  </Link>
                  {/* <h2 className="project-name" data-test="project name">
                  {this.openProjectPageBasedOnLink(true)}
                </h2> */}
                  {get(project, "projectStatusWithRespectToIssueStatus") ||
                  get(project, "projectCompletionDTO.status") ? (
                    <div className="project-status">
                      {get(project, "projectStatusWithRespectToIssueStatus") &&
                      get(project, "projectStatusWithRespectToIssueStatus") !==
                        "NO ISSUES" ? (
                        <></>
                      ) : null}

                      {get(project, "projectCompletionDTO.status") ? (
                        <span className="pragati-page-status">
                          {get(project, "projectCompletionDTO.status") ===
                          "NO IMPLEMENTATION"
                            ? "UNDER DEVELOPMENT"
                            : get(project, "projectCompletionDTO.status")}
                        </span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                className="project-box-top-lower"
                style={{
                  alignItems: "flex-start",
                  paddingTop:
                    get(project, "projectCompletionDTO.status") &&
                    get(project, "projectCompletionDTO.status") !==
                      "NO IMPLEMENTATION"
                      ? 20
                      : null
                }}
              >
                <div className="project-details-left-section">
                  <div className="pragati-project-detail-unit display-mobile">
                    {/* <div className="heading-text">Project Id - </div> */}
                    {/* <b>{this.openProjectPageBasedOnLink()}</b> */}
                  </div>
                  {/* {organistionArr && organistionArr.length ? (
                  <div className="pragati-project-detail-unit display-mobile">
                    <div className="heading-text">pragati-page-organisation:</div>
                    <div>
                      {organistionArr.map((item, index) => (
                        <span>
                          {item.organizationGroup}
                          {index < organistionArr.length - 1
                            ? ", "
                            : ""}{" "}
                        </span>
                      ))}
                    </div>
                  </div>
                ) : null} */}
                  <div className="pragati-project-detail-unit">
                    <div className="heading-text">
                      Sponsoring Ministry:&nbsp;
                    </div>
                    <span
                      style={{
                        color: "#2E2E2E",
                        fontFamily: "mpr",
                        marginLeft: 4
                      }}
                    >
                      {" "}
                      {get(project, "sponsoredBy")}
                    </span>
                  </div>
                  {get(project, "sponsoringDepartment") ? (
                    <div className="pragati-project-detail-unit">
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Sponsoring Department"
                        )}
                        :&nbsp;
                      </div>
                      <span
                        style={{
                          color: "#2E2E2E",
                          fontFamily: "mpr",
                          marginLeft: 4
                        }}
                      >
                        {" "}
                        {get(project, "sponsoringDepartment.name")}
                      </span>
                    </div>
                  ) : null}
                  {isValidArray(get(project, "locations")) ? (
                    <div className="pragati-project-detail-unit">
                      <div className="heading-text">
                        Project Location:&nbsp;
                      </div>
                      <ReadMore
                        content={
                          <span
                            style={{
                              color: "#2E2E2E",
                              fontFamily: "mpr",
                              marginLeft: 4
                            }}
                          >
                            {" "}
                            {projectLocations}
                          </span>
                        }
                        clamp={3}
                        displayExpandButtons={false}
                        fontweightcss={true}
                      />
                    </div>
                  ) : null}

                  <div
                    className="project-issues-details"
                    style={{
                      fontSize: 14,
                      fontFamily: "mpsb",
                      lineHeight: "13px"
                    }}
                  >
                    Issue(s) Open:{" "}
                    <span style={{ color: "#2E2E2E", fontFamily: "mpr" }}>
                      {get(project, "openIssuesCount", 0)}
                    </span>{" "}
                    <span style={{ color: "#525252" }}>|</span> Issue(s)
                    Resolved:{" "}
                    <span style={{ color: "#2E2E2E", fontFamily: "mpr" }}>
                      {get(project, "resolvedIssuesCount", 0)}
                    </span>
                  </div>

                  {/* <div className="project-issues-details space-border-left">
                 
                </div> */}

                  {get(project, "projectCompletionDTO") &&
                  get(project, "projectCompletionDTO.percentage") ? (
                    <div className="physical-progress-wrapper">
                      <div
                        className="progress-upper d-flex align-items-center fw-bold"
                        style={{ marginTop: 10, fontSize: 14 }}
                      >
                        Physical Progress:{" "}
                        <span className="d-inline-block">
                          {get(project, "projectCompletionDTO.percentage")}%
                        </span>
                      </div>
                      {get(
                        project,
                        "projectCompletionDTO.physicalProgressAsOf"
                      ) ? (
                        <div
                          className="progress-lower"
                          style={{ color: "#525252" }}
                        >
                          (as of{" "}
                          {dateFormat(
                            get(
                              project,
                              "projectCompletionDTO.physicalProgressAsOf"
                            )
                          )}
                          )
                        </div>
                      ) : get(project, "projectCompletionDTO.date") ? (
                        <div
                          className="progress-lower"
                          style={{ color: "#525252" }}
                        >
                          (as of{" "}
                          {dateFormat(
                            get(project, "projectCompletionDTO.date")
                          )}
                          )
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="project-details-right-section">
                  {/* <div className="project-impl-mode">
                                  Impl. Mode - {get(project, "implMode", "NA")}
                              </div> */}
                  <div
                    className="project-list-box-bottom"
                    style={{ paddingTop: 0, alignItems: "flex-start" }}
                  >
                    <div className="project-bottom-left">
                      <div
                        className="d-flex tags-contatiner"
                        style={{
                          float: "right",
                          marginRight: "-7px",
                          marginTop: "0px"
                        }}
                      >
                        <Pragati
                          className={"pragati-review-detail-page"}
                          isValidProject={get(
                            project,
                            "pragatiDTO.pragatiReview"
                          )}
                          prgaticss={
                            get(project, "pragatiDTO.pragatiReview")
                              ? false
                              : true
                          }
                        />
                        <PragatiPipeline
                          className={"pragati-review-detail-page"}
                          isValidProject={
                            !get(project, "pragatiDTO.pragatiReview") &&
                            get(project, "pragatiDTO.pragatiPipeline")
                          }
                        />
                        <Nip
                          className={"pragati-review-detail-page"}
                          isValidProject={get(project, "nipDTO.nipReview")}
                        />
                        <PmFoundationStone
                          className={"pragati-review-detail-page"}
                          isValidProject={get(
                            project,
                            "pmFoundationStoneDTO.pmFoundationStone"
                          )}
                        />
                        <CmPragatiYatra
                          className={"pragati-review-detail-page"}
                          isValidProject={get(
                            project,
                            "cmPragatiYatraDTO.cmPragatiYatra"
                          )}
                        />
                        <CmFoundationStone
                          className={"pragati-review-detail-page"}
                          isValidProject={get(
                            project,
                            "cmFoundationStoneDTO.cmFoundationStone"
                          )}
                        />
                        <PmGatiShakti
                          className={"pragati-review-detail-page"}
                          isValidProject={get(
                            project,
                            "pmGatiShaktiNewDTO.pmGatiShaktiNew"
                          )}
                        />

                        <PmgsHipimage
                          className={"pragati-review-detail-page"}
                          isValidProject={get(project, "pmGsHipDTO.pmgsHip")}
                        />
                        <Pli
                          className={"pragati-review-detail-page"}
                          isValidProject={get(project, "pliDTO.pli")}
                        />
                        <March24
                          className={"pragati-review-detail-page"}
                          isValidProject={get(project, "march24DTO.march24")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pragati-project-cost-section">
                    <label>Project Cost</label>
                    <p className="pragati-page-cost">
                      {parseFloat(projectCost) !== 0
                        ? `₹ ${projectCost} Cr.`
                        : "N/A"}
                    </p>
                  </div>
                  <div className="project-created-date">
                    <span
                      className={`project-created-by
                                    ${
                                      createdBy && createdBy.verified
                                        ? "verified-user"
                                        : ""
                                    }
                                    `}
                      style={{ fontSize: 15, paddingLeft: 23 }}
                    />
                    <span className="first-pp-name">
                      <RedirectUser
                        title={get(createdBy, "name", null)}
                        id={get(createdBy, "id", null)}
                        isProjectProponentDetail={true}
                        data-test="first-pp-name"
                      />
                    </span>
                    {projectPPList && projectPPList.length > 1 ? (
                      <div
                        className={`dropdown field-sort ${
                          showOtherPPList ? "visible" : ""
                        }`}
                        //onClick={this.toggleOtherPPList}
                        onClick={onChangePPList}
                      >
                        <div
                          className={`dropdown-overlay ${
                            showOtherPPList ? "visible" : ""
                          }`}
                        />
                        <div className="dropdown-selected-value">
                          + {projectPPList.length - 1}
                        </div>
                        <div className="dropdown-option-list hidden-mobile">
                          <div className="dropdown-option-list-heading" />
                          {projectPPList
                            ? projectPPList.map((value, index) => {
                                if (index !== 0) {
                                  return (
                                    <RedirectUser
                                      title={get(value, "name", null)}
                                      id={get(value, "id", null)}
                                      isProjectProponentDetail={true}
                                    />
                                  );
                                }
                              })
                            : null}
                        </div>
                      </div>
                    ) : null}
                    <span className="project-created-on decision-submitted-on">
                      {get(project, "verificationDate")
                        ? `Verified on: ${dateFormat(
                            get(project, "verificationDate", null)
                          )}`
                        : `${isIIGDraft ? "Created on" : "Created on"}
                    ${dateFormat(get(project, "createdDate", null))}`}
                    </span>
                  </div>
                </div>
              </div>
              <div>
                {get(project, "projectDecisions") == null ||
                get(project, "projectDecisions").length == 0 ? null : (
                  <>
                    {//get(agendaData, "meetingStatus")=="DRAFT"
                    get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                      <>
                        <h2 className="pragati-minutes-heading">
                          Minutes of Meeting
                        </h2>
                        <span className="pragati-minutes-text">
                          {/* {project.projectDecisions[0].projectmom} */}
                          <ReadMore
                            clamp={5}
                            //displayExpandButtons={false}
                            content={project.projectDecisions[0].projectmom}
                            fontweightcss={true}
                          />
                        </span>
                      </>
                    ) : null}
                  </>
                )}
              </div>
              <div
                style={{
                  paddingTop:
                    (get(project, "projectDecisions[0].projectmom") == null ||
                      get(project, "projectDecisions[0].projectmom") == "") &&
                    (get(project, "projectDecisions[0].fileDTOList") !== null ||
                      get(project, "projectDecisions[0].fileDTOList").length !==
                        0)
                      ? 0
                      : 15,
                  display:
                    get(agendaData, "meetingStatus") == "CONCLUDED"
                      ? null
                      : "none"
                }}
              >
                {get(project, "projectDecisions[0].fileDTOList") == null ||
                get(project, "projectDecisions[0].fileDTOList").length ==
                  0 ? null : (
                  <>
                    {//get(agendaData, "meetingStatus")=="DRAFT"
                    get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                      <>
                        <div className="momDesc momDesc-project">
                          <div className="agenda-decision-container">
                            <div className="attachmentsDetails">
                              <img
                                src={Attachment}
                                alt="attachment icon"
                                //className="mr-1 attachmentIcon"
                                className="mr-1"
                              />
                              <div className="meeting-attachments">
                                {meetingOm.map((val, index) => {
                                  const extension = val.name.substr(
                                    val.name.lastIndexOf(".") + 1,
                                    val.name.length
                                  );
                                  return (
                                    <>
                                      <div
                                        className="momdesc_attachment"
                                        style={{
                                          fontFamily: "mpsb",
                                          fontSize: 12
                                        }}
                                      >
                                        <a
                                          href={val.s3Url}
                                          rel="noopener noreferrer"
                                          target="_blank"
                                          className="om_attachment_link"
                                          //id="pragati-detail-attach"
                                        >
                                          {val.title != null
                                            ? val.title.length > 20
                                              ? val.title.substring(0, 20) +
                                                "..."
                                              : val.title
                                            : val.name.length > 20
                                            ? val.name.substring(0, 20) + "..."
                                            : val.name}
                                          {/* {truncateWithEllipsis(val.name.substring(0, val.name.lastIndexOf(".")),32)} */}
                                          {index < meetingOm.length - 1 ? (
                                            <>
                                              {", "}
                                              <span
                                                style={{ whiteSpace: "pre" }}
                                              >
                                                {"\u00A0"}
                                              </span>
                                            </>
                                          ) : (
                                            <> </>
                                          )}
                                          {/* &nbsp;{"  "}&nbsp; */}
                                        </a>
                                        <div
                                          class="attachment-added"
                                          style={{
                                            left: "auto",
                                            width: "max-content"
                                          }}
                                        >
                                          <div
                                            class="project-download-icons"
                                            style={{ marginRight: 0 }}
                                          >
                                            <div class="download-icons-pdf">
                                              {extension}
                                            </div>
                                            <a
                                              target="_blank"
                                              href={val.s3Url}
                                              download={val.s3Url}
                                              rel="noopener noreferrer"
                                            >
                                              {val.title != null
                                                ? val.title
                                                : val.name}
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <label class="meeting-om-attachment">
                          {/* <img src={Attachment} style={{verticalAlign:"top"}} />   */}
                          {/* {meetingOm.map((e)=>(
      <>
       <a
     className="om_attachment_link"
     target="_blank"
     href={e.s3Url}
    id="pragati-detail-attach"
   >
     {truncateWithEllipsis(e.name.substring(0, e.name.lastIndexOf(".")),32)}
   </a>
   <div class="attachment-added-tooltip-om pragati">
     <div class="project-download-icons" style={{marginBottom:0}}>
       <div class="download-icons-pdf">{e.name
    .substr(e.name.lastIndexOf(".") + 1, e.name.length)
    .toLowerCase()}</div>
       <a
         target="_blank"
         href={e.s3Url}
         download={e.s3Url}
         rel="noopener noreferrer"
         style={{paddingLeft:6,paddingRight:0,textDecoration:"none"}}
       >
          {e.name}
       </a>
     </div>
   </div>
      </>
     ))} */}

                          {/* <div className="meeting-attachments">
                            {meetingOm.map(
                              (val, index) => {
                                const extension = val.name.substr(
                                  val.name.lastIndexOf(".") + 1,
                                  val.name.length
                                );
                                return (
                                  <>
                                    <div className="momdesc_attachment">
                                      <a
                                        href={val.s3Url}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        className="om_attachment_link"
                                        id="pragati-detail-attach"
                                      >
                                        {val.title}
                                        {val.title != null
                                          ? val.title.length > 20
                                            ? val.title.substring(0, 20) + "..."
                                            : val.title
                                          : val.name.length > 20
                                          ? val.name.substring(0, 20) + "..."
                                          : val.name}
{truncateWithEllipsis(val.name.substring(0, val.name.lastIndexOf(".")),32)}
                                        {index <
                                        meetingOm
                                          .length -
                                          1 ? (
                                          <>
                                            {", "}
                                            <span style={{ whiteSpace: "pre" }}>
                                              {"\u00A0"}
                                            </span>
                                          </>
                                        ) : (
                                          <> </>
                                        )}
                                        
                                      </a>
                                      <div class="attachment-added-tooltip-om pragati">
                                        <div class="project-download-icons">
                                          <div class="download-icons-pdf">
                                          {extension}
                                          </div>
                                          <a
                                            target="_blank"
                                            href={val.s3Url}
                                            download={val.s3Url}
                                            rel="noopener noreferrer"
                                            style={{paddingLeft:6,paddingRight:0,textDecoration:"none"}}
                                          >
                                            {val.title != null
                                              ? val.title
                                              : val.name}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            )}
                          </div> */}
                        </label>
                      </>
                    ) : null}
                  </>
                )}
              </div>
              {/* {console.log(fileDTOList)}
            <div style={{paddingTop:10}}>
            <label class="meeting-om-attachment">
 <img src={Attachment} style={{verticalAlign:"top"}} />  
     
   <a
     className="om_attachment_link"
     target="_blank"
     href={meetingOm[0].s3Url}
    id="pragati-detail-attach"
   >
     {truncateWithEllipsis(meetingOm[0].name.substring(0, meetingOm[0].name.lastIndexOf(".")),32)}
   </a>
   <div class="attachment-added-tooltip-om pragati">
     <div class="project-download-icons" style={{marginBottom:0}}>
       <div class="download-icons-pdf">{meetingOm[0].name
    .substr(meetingOm[0].name.lastIndexOf(".") + 1, meetingOm[0].name.length)
    .toLowerCase()}</div>
       <a
         target="_blank"
         href={meetingOm[0].s3Url}
         download={meetingOm[0].s3Url}
         rel="noopener noreferrer"
         style={{paddingLeft:6,paddingRight:0,textDecoration:"none"}}
       >
          {meetingOm[0].name}
       </a>
     </div>
   </div>
 

</label>

           
            </div> */}
              {get(project, "projectDecisions") == null ||
              get(project, "projectDecisions").length == 0 ? null : (
                <>
                  {//get(agendaData, "meetingStatus")=="DRAFT"
                  get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                    <>
                      <div
                        style={{
                          paddingBottom: 20,
                          paddingTop: meetingOm.length == 0 ? 0 : null
                        }}
                      >
                        <div
                          className="project-created-date"
                          style={{ display: "flex", float: "right" }}
                        >
                          <span
                            className={`project-created-by
                                    ${
                                      createdBy && createdBy.verified
                                        ? "verified-user"
                                        : ""
                                    }
                                    `}
                          />
                          <span className="first-pp-name decission-section">
                            <RedirectUser
                              title={get(
                                decisionscreatedBy,
                                "decisionCreatedByName",
                                null
                              )}
                              id={get(
                                decisionscreatedBy,
                                "decisionCreatedById",
                                null
                              )}
                              isProjectProponentDetail={true}
                              data-test="first-pp-name"
                            />
                          </span>
                          <span className="project-created-on decision-submitted-on">
                            {get(project, "verificationDate")
                              ? `Decision Submitted on : ${dateFormat(
                                  get(decisionscreatedBy, "createdDate", null)
                                )}`
                              : `${isIIGDraft ? "Created on" : "Created on"}
                    ${dateFormat(get(project, "createdDate", null))}`}
                          </span>
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </div>
          </div>
        </div>

        {/* {project.issuesSelected.map((item, index) => (
        <>
          <IssueSingle
            issue={item}
            idx={item.id}
            key={index}
            deleteHandler={this.deleteSingleIssueHandler}
            fromCreateAgendaPage={true}
            IssueSelected="delete"
          />
        </>
      ))} */}
      </div>
      {issues.map((issue, index) => {
        const issuedecisionscreatedBy =
          issue.meetingDecisionDTOS && issue.meetingDecisionDTOS.length
            ? issue.meetingDecisionDTOS[0]
            : null;
        let issueMeetingOm = get(
          issue,
          "meetingDecisionDTOS[0].fileDTOList",
          []
        );
        const isPragatiReview = get(issue, "issuePragatiReview");
        const isPragatiPipeline = get(issue, "issuePragatiPipeLine");
        return (
          <div
            className="select-issue-wrapper-pragati"
            style={{
              borderRadius:
                index == issues.length - 1 ? "0px 0px 4px 4px" : null,
              borderBottom: "1px solid #C7C7C7"
            }}
          >
            <div
              className="select-issue-content"
              style={{ width: "-webkit-fill-available" }}
            >
              <div className="issue-list-top" style={{ padding: "20px 30px" }}>
                <div className="issue-list-header">
                  <span
                    className={`issue-number ${
                      get(issue, "duplicate") ? "duplicate-issue-number" : ""
                    }`}
                  >
                    {get(issue, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
                    <b>
                      <Link
                        to={{
                          pathname: PATHS.ISSUE_DETAIL,
                          search: `?issueId=${get(
                            issue,
                            "id"
                          )}&&projectId=${get(issue, "projectId")}`
                        }}
                      >
                        #{get(issue, "displayId", null)}-
                        {get(issue, "id", null)}
                      </Link>
                    </b>
                    {/**CR 289 Changes Starts-Yajnadutta */}
                    {get(issue, "escalationLevelName", "NA") == null ? null : (
                      <EscalationLevelModal
                        IssueId={get(issue, "id")}
                        EscalationName={get(issue, "escalationLevelName", "NA")}
                        pragatiDetailPage={true}
                        pragatiDetailPageCss={true}
                      />
                    )}
                    {/**CR 289 Changes End-Yajnadutta */}
                  </span>
                  <OverlayTrigger
                    defaultShow={false}
                    trigger="hover"
                    placement="top"
                    overlay={
                      <Tooltip className="issues-status-tooltip ">
                        {toolttipDisplayMessage(get(issue, "status", "NA"))}
                      </Tooltip>
                    }
                  >
                    <span>
                      <Button
                        className={`btn-extra-small animated flipInX pragatibtn ${getColor(
                          get(issue, "status", "NA").toLowerCase()
                        )} unClickable`}
                        style={{
                          borderRadius: 50,
                          padding: "4px 10px",
                          fontSize: 11,
                          marginLeft: 10,
                          lineHeight: "10px",
                          height: 20,
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        {get(issue, "status", "NA")}
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <Link
                    to={{
                      pathname: PATHS.ISSUE_DETAIL,
                      search: `?issueId=${get(issue, "id")}&&projectId=${get(
                        issue,
                        "projectId"
                      )}`
                    }}
                  >
                    <h2
                      className={`issue-title ${
                        get(issue, "title").match(/[\u0900-\u097F]/)
                          ? "hindi-text-wrap"
                          : ""
                      }`}
                    >
                      {get(issue, "title", null)}
                    </h2>
                  </Link>
                  <div />
                </div>
              </div>
              <div
                className="issue-list-middle issue-list-align"
                style={{ lineHeight: "23px", padding: "0 30px" }}
              >
                <div className="issue-list-desc-wrapper">
                  <span className="issue-recipient">
                    <span className="issue-recipient-title">
                      Recipient{" "}
                      {transformProjectCategoryId(
                        get(issue, "recipientGroupCategory")
                      )}
                      : &nbsp;
                    </span>
                    {get(issue, "recipientState", "NA")}
                  </span>
                  {get(issue, "districtName") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        {get(issue, "recipientLabel")}: &nbsp;
                      </span>
                      {get(issue, "districtName")}
                    </span>
                  ) : null}
                  {get(issue, "secondaryState") ||
                  get(issue, "secondaryRecipientGroupName") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        Secondary Recipient -{" "}
                      </span>
                      {get(issue, "secondaryState") ||
                        get(issue, "secondaryRecipientGroupName")}
                    </span>
                  ) : get(issue, "secondaryMinistry") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        Secondary Recipient -{" "}
                      </span>
                      {get(issue, "secondaryMinistry")}
                    </span>
                  ) : null}
                  <p
                    className="issue-category to-n-fro"
                    style={{ marginBottom: 5, marginTop: 0 }}
                  >
                    <span className="issue-category-title">
                      Issue Category: &nbsp;
                    </span>
                    {get(issue, "category", null)}

                    <span className="clowdy" />
                  </p>
                  {get(issue, "subCategory") ? (
                    <p className="issue-sub-category to-n-fro">
                      <span className="issue-category-title">
                        Issue Sub-Category: &nbsp;
                      </span>
                      {get(issue, "subCategory", null)}

                      <span className="clowdy" />
                    </p>
                  ) : null}
                </div>
                {/* {get(agendaData, "meetingStatus") !== "CONCLUDED" ? (
                <></>
                ) : null} */}
                {/* {issue.meetingDecisionDTOS == null ||
                issue.meetingDecisionDTOS.length == 0 ? (
                  <AgendaIssuePragatiReview
                    isPragati={get(issue, "issuePragatiReview")}
                    isAgendaDetail={true}
                    className="issue_pragati_agenda_flag agenda_detail"
                  />
                ) : null} */}
                {get(agendaData, "meetingStatus") !== "CONCLUDED" ? (
                  <>
                    {/* <AgendaIssuePragatiReview
                    isPragati={get(issue, 'issuePragatiReview')}
                    isAgendaDetail={true}
                    className="issue_pragati_agenda_flag agenda_detail dg"
                  /> */}
                    {isPragatiReview ? (
                      <AgendaIssuePragatiReview
                        isPragati={isPragatiReview}
                        isAgendaDetail={true}
                        className="issue_pragati_agenda_flag agenda_detail dg"
                      />
                    ) : isPragatiPipeline ? (
                      <AgendaIssuePragatiPipeline
                        isPragatiPipeline={isPragatiPipeline}
                        isAgendaDetail={true}
                        className="issue_pragati_pipeline_agenda_flag agenda_detail dg"
                      />
                    ) : null}
                  </>
                ) : issue.meetingDecisionDTOS == null ||
                  issue.meetingDecisionDTOS.length == 0 ? (
                  <>
                    {/* <AgendaIssuePragatiReview
                    isPragati={get(issue, 'issuePragatiReview')}
                    isAgendaDetail={true}
                    className="issue_pragati_agenda_flag agenda_detail check-mom"
                  /> */}
                    {isPragatiReview ? (
                      <AgendaIssuePragatiReview
                        isPragati={isPragatiReview}
                        isAgendaDetail={true}
                        className="issue_pragati_agenda_flag agenda_detail check-mom"
                      />
                    ) : isPragatiPipeline ? (
                      <AgendaIssuePragatiPipeline
                        isPragatiPipeline={isPragatiPipeline}
                        isAgendaDetail={true}
                        className="issue_pragati_pipeline_agenda_flag agenda_detail check-mom"
                      />
                    ) : null}
                  </>
                ) : null}
              </div>
              {/* {get(agendaData, "meetingStatus") === "CONCLUDED" ? ( */}
              <div
                style={{
                  padding: "20px 30px",
                  marginTop:
                    issue.meetingDecisionDTOS.length != 0 ? "-3em" : "-4em"
                }}
              >
                <div>
                  {issue.meetingDecisionDTOS == null ||
                  issue.meetingDecisionDTOS.length == 0 ? null : (
                    <>
                      {//get(agendaData, "meetingStatus")=="DRAFT"
                      get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                        <>
                          <h2 className="pragati-minutes-heading">
                            Minutes of Meeting
                          </h2>
                          <span className="pragati-minutes-text">
                            <ReadMore
                              clamp={5}
                              //displayExpandButtons={false}
                              content={
                                issue.meetingDecisionDTOS[0].meetingDescription
                              }
                              fontweightcss={true}
                            />
                          </span>
                        </>
                      ) : null}
                    </>
                  )}
                </div>
                {issue.meetingDecisionDTOS == null ||
                issue.meetingDecisionDTOS.length == 0 ? null : (
                  <>
                    {//get(agendaData, "meetingStatus")=="DRAFT"
                    get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                      <>
                        {issue.meetingDecisionDTOS[0].taskCompletionDate ==
                        null ? null : (
                          <>
                            <div style={{ paddingTop: 22 }}>
                              <span className="issue-resolution-date-heading">
                                Issue Resolution Date:{" "}
                              </span>
                              <span style={{ color: "#525252" }}>
                                {dateFormat(
                                  issue.meetingDecisionDTOS[0]
                                    .taskCompletionDate
                                )}
                              </span>
                            </div>
                          </>
                        )}
                      </>
                    ) : null}
                  </>
                )}

                <div
                  style={{
                    paddingTop:
                      issue.meetingDecisionDTOS.length != 0 &&
                      issue.meetingDecisionDTOS[0].task1 == null &&
                      get(agendaData, "meetingStatus") == "CONCLUDED"
                        ? 0
                        : 20
                  }}
                  className="issue-state-pragati-detail"
                >
                  {issue.meetingDecisionDTOS == null ||
                  issue.meetingDecisionDTOS.length == 0 ? null : (
                    <>
                      {//get(agendaData, "meetingStatus")=="DRAFT"
                      get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                        <>
                          {issue.meetingDecisionDTOS[0].task1 == null ||
                          issue.meetingDecisionDTOS[0].task1CompletionDate ==
                            null ? null : (
                            <>
                              <span className="issue-resolution-date-heading">
                                Intermediate Tasks
                              </span>
                              <br />
                              <li style={{ lineHeight: "20px", marginTop: 5 }}>
                                <span
                                  className="pragati-minutes-text"
                                  style={{
                                    marginLeft: "-0.5em",
                                    verticalAlign: "text-top"
                                  }}
                                >
                                  {" "}
                                  {issue.meetingDecisionDTOS[0].task1}
                                </span>
                                <p style={{ marginLeft: "0.6em" }}>
                                  <span
                                    className="issue-resolution-date-heading"
                                    style={{ fontSize: 14 }}
                                  >
                                    {" "}
                                    Completion Date:{" "}
                                  </span>
                                  <span className="pragati-minutes-text">
                                    {dateFormat(
                                      issue.meetingDecisionDTOS[0]
                                        .task1CompletionDate
                                    )}
                                  </span>
                                </p>
                              </li>
                            </>
                          )}
                          {issue.meetingDecisionDTOS[0].task2 == null ||
                          issue.meetingDecisionDTOS[0].task2CompletionDate ==
                            null ? null : (
                            <>
                              <li
                                style={{
                                  lineHeight: "20px",
                                  marginTop: "-1em"
                                }}
                              >
                                <span
                                  className="pragati-minutes-text"
                                  style={{
                                    marginLeft: "-0.5em",
                                    verticalAlign: "text-top"
                                  }}
                                >
                                  {" "}
                                  {issue.meetingDecisionDTOS[0].task2}
                                </span>
                                <p style={{ marginLeft: "0.6em" }}>
                                  <span
                                    className="issue-resolution-date-heading"
                                    style={{ fontSize: 14 }}
                                  >
                                    {" "}
                                    Completion Date:{" "}
                                  </span>
                                  <span className="pragati-minutes-text">
                                    {dateFormat(
                                      issue.meetingDecisionDTOS[0]
                                        .task2CompletionDate
                                    )}
                                  </span>
                                </p>
                              </li>
                            </>
                          )}
                        </>
                      ) : null}
                    </>
                  )}
                </div>

                {issue.meetingDecisionDTOS == null ||
                issue.meetingDecisionDTOS.length == 0 ? null : (
                  <>
                    {//get(agendaData, "meetingStatus")=="DRAFT"
                    get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                      <>
                        <div>
                          {issueMeetingOm.length == 0 ? null : (
                            <>
                              <label class="meeting-om-attachment">
                                <img
                                  src={Attachment}
                                  style={{ verticalAlign: "top" }}
                                />

                                <a
                                  className="om_attachment_link"
                                  target="_blank"
                                  href={issueMeetingOm[0].s3Url}
                                  id="pragati-detail-attach"
                                >
                                  {truncateWithEllipsis(
                                    issueMeetingOm[0].name.substring(
                                      0,
                                      issueMeetingOm[0].name.lastIndexOf(".")
                                    ),
                                    32
                                  )}
                                </a>
                                <div class="attachment-added-tooltip-om pragati">
                                  <div
                                    class="project-download-icons"
                                    style={{ marginBottom: 0 }}
                                  >
                                    <div class="download-icons-pdf">
                                      {issueMeetingOm[0].name
                                        .substr(
                                          issueMeetingOm[0].name.lastIndexOf(
                                            "."
                                          ) + 1,
                                          issueMeetingOm[0].name.length
                                        )
                                        .toLowerCase()}
                                    </div>
                                    <a
                                      target="_blank"
                                      href={issueMeetingOm[0].s3Url}
                                      download={issueMeetingOm[0].s3Url}
                                      rel="noopener noreferrer"
                                      style={{
                                        paddingLeft: 6,
                                        paddingRight: 0,
                                        textDecoration: "none"
                                      }}
                                    >
                                      {issueMeetingOm[0].name}
                                    </a>
                                  </div>
                                </div>
                              </label>
                            </>
                          )}
                        </div>
                      </>
                    ) : null}
                  </>
                )}

                {issue.meetingDecisionDTOS == null ||
                issue.meetingDecisionDTOS.length == 0 ? null : (
                  <>
                    {//get(agendaData, "meetingStatus")=="DRAFT"
                    get(agendaData, "meetingStatus") == "CONCLUDED" ? (
                      <>
                        <div
                          style={{
                            paddingBottom: 20,
                            paddingTop: issueMeetingOm.length == 0 ? null : null
                          }}
                        >
                          {/* <AgendaIssuePragatiReview 
                            isPragati={get(issue, "issuePragatiReview")}
                            isAgendaDetail={true}
                            className="issue_pragati_agenda_flag agenda_detail"
                          /> */}
                          {isPragatiReview ? (
                            <AgendaIssuePragatiReview
                              isPragati={isPragatiReview}
                              isAgendaDetail={true}
                              className="issue_pragati_agenda_flag agenda_detail"
                            />
                          ) : isPragatiPipeline ? (
                            <AgendaIssuePragatiPipeline
                              isPragatiPipeline={isPragatiPipeline}
                              isAgendaDetail={true}
                              className="issue_pragati_pipeline_agenda_flag agenda_detail"
                            />
                          ) : null}
                          <div
                            className="project-created-date"
                            style={{ display: "flex", float: "right" }}
                          >
                            <span
                              className={`project-created-by
                                 ${
                                   createdBy && createdBy.verified
                                     ? "verified-user"
                                     : ""
                                 }
                                 `}
                            />
                            <span className="first-pp-name decission-section">
                              <RedirectUser
                                title={get(
                                  issuedecisionscreatedBy,
                                  "decisionCreatedBy",
                                  null
                                )}
                                id={get(
                                  issuedecisionscreatedBy,
                                  "decisionCreatedById",
                                  null
                                )}
                                isProjectProponentDetail={true}
                                data-test="first-pp-name"
                              />
                            </span>
                            <span className="project-created-on decision-submitted-on">
                              {get(project, "verificationDate")
                                ? `Decision Submitted on : ${dateFormat(
                                    get(
                                      issuedecisionscreatedBy,
                                      "decisionSubmittedOn",
                                      null
                                    )
                                  )}`
                                : `${isIIGDraft ? "Created on" : "Created on"}
                 ${dateFormat(get(project, "createdDate", null))}`}
                            </span>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </>
                )}
              </div>
              {/* ) : null} */}
            </div>
          </div>
        );
      })}
    </div>

    // <div className="card">
    //   <h3 className="card-title">{project.name}</h3>
    //   <ul>
    //     <li key={project.id}>
    //       <b>Project:</b> {project.id} - {project.name}
    //     </li>

    //     {issue && (
    //       <li key={issue.id}>
    //         <b>Issue:</b> {issue.id} - {issue.name}
    //       </li>
    //     )}
    //   </ul>
    // </div>
  );
};
class IssueSingleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addDecision: false,
      editDecision: false,
      viewMoreStatus: false,
      project: {},
      issueAction: false,
      showOtherPPList: false,
      projectDetail: []
    };
  }

  onToggleModal = () => {
    this.setState(prevState => ({
      displayPopUp: !prevState["displayPopUp"],
      viewMoreStatus: false
    }));
  };

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  handleViewMore = () => {
    this.onToggleModal();
    this.setState({
      viewMoreStatus: true
    });
  };

  redirectToAgenda = e => {
    let { changeAgendaDetail } = this.props;
    let agendaId = e.target.innerHTML && e.target.innerHTML.replace("#", "");
    this.onToggleModal();
    changeAgendaDetail(agendaId);
  };

  onActionClick = () => {
    let { getActions, issues } = this.props;
    this.setState(
      {
        issueAction: !this.state.issueAction
      },
      async () => {
        if (this.state.issueAction) {
          const response =
            get(issues, "id") &&
            (await getActions(undefined, get(issues, "id")));
          if (response) {
            const { data, status } = response;
            this.setState({
              actionsData: data,
              isActionLoading: (status && STATUS.SUCCESS) || STATUS.ERROR
            });
          }
        }
      }
    );
  };

  callApiOnSuccess = () => {
    const {
      props: {
        _getIssueList,
        getMomDetails,
        agendaData,
        issueListReducer: { selectedFilters }
      }
    } = this;
    _getIssueList({
      ...selectedFilters
    });
    getMomDetails(undefined, { momId: get(agendaData, "id") });
    this.setState({
      issueAction: !this.state.issueAction
    });
  };

  componentDidMount = async () => {
    const { issues, projectData, agendaData, issuesData } = this.props;
    // const uniqueData = projectData.reduce((acc, current) => {
    //   const existing = acc.find(item => item.projectId === current.projectId);
    //   if (!existing) {
    //     acc.push(current);
    //   }
    //   return acc;
    // }, []);

    // let projectId = issues.projectId
    // const response = await request(
    //   getProjectDetailsforPragti(get(agendaData, "id"))
    // );
    // console.log(agendaData);
    //this.props.onChangeCount(response.data.data.projectsData.length,response.data.data.issuesData.length,1)
    const mergedArray = projectData.map(project => {
      const matchingIssues = issuesData.filter(
        issue => issue.projectId === project.id
      );
      return [project, ...matchingIssues];
    });
    //console.log(mergedArray)
    this.setState({ projectDetail: mergedArray }, () => {
      //console.log(this.state.projectDetail)
    });

    // this.setState({ projectId: newItems1}, () => {
    //   console.log(this.state.projectId); // This will now log the updated state
    // });
    //project object used to syn keys on add decision component
    // let project = {
    //   totalCost: issues.totalCost,
    //   displayId: issues.displayId,
    //   name: issues.projectName,
    //   sponsoredBy: issues.sponsoringMinistry,
    //   pendingIssue: issues.pendingIssue,
    //   organizationName: issues.organizationName,
    //   projectStatusWithRespectToIssueStatus:
    //     issues.projectStatusWithRespectToIssueStatus,
    //   projectCompletionDTO: issues.projectCompletionDTO,
    //   projectPPList: issues.projectPPList,
    //   openIssuesCount: issues.openIssuesCount,
    //   resolvedIssuesCount: issues.resolvedIssuesCount,
    // };
    // this.setState({
    //   project
    // });
  };

  render() {
    const { issues, agendaData, handleUpdateStatus, permission } = this.props;
    // const {
    //   displayPopUp,
    //   viewMoreStatus,
    //   project,
    //   actionsData,
    //   isActionLoading,
    //   issueAction,
    //   showOtherPPList,
    //   projectDetail
    // } = this.state;
    // const { groupCategory } = getLocalstorage("user");
    // const showMeetingData = get(issues, "meetingDecisionDTOS", []).find(
    //   value => {
    //     return agendaData.id === value.meetingId;
    //   }
    // );
    // let displayActions = shouldDisplayIssueAction(actionsData);

    // let pendingWithSMAndPMG =
    //   !(
    //     get(issues, "status") == ISSUE_STATUS["Pending with PMG"] ||
    //     get(issues, "status") == ISSUE_STATUS["Pending with SM"]
    //   ) || get(showMeetingData, "decisionStatus") === "DRAFT";

    // const createdBy =
    //   issues.projectPPList && issues.projectPPList.length
    //     ? issues.projectPPList[0]
    //     : null;
    // const projectPPList =
    //   issues.projectPPList && issues.projectPPList.length
    //     ? issues.projectPPList
    //     : [];
    // const projectCost = formatNumber(
    //   get(project, "revisedCost", 0) || get(issues, "totalCost", "0")
    // );
    // let projectLocations = [];
    // if (isValidArray(get(projectDetail, "locations"))) {
    //   projectLocations = get(projectDetail, "locations").map((location, index) =>
    //     index < get(projectDetail, "locations").length - 1
    //       ? location.state + ", "
    //       : location.state + ""
    //   );
    // }
    // const isIIGDraft = "iig draft";

    return (
      <>
        {this.state.projectDetail.map((projectAndIssue, index) => (
          <ProjectCard
            key={projectAndIssue[0].id}
            project={projectAndIssue[0]}
            issues={projectAndIssue.slice(1)}
            agendaData={agendaData}
            index={index}
            showOtherPPList={this.state.showOtherPPList}
            onChangePPList={this.toggleOtherPPList}
            issuesforattachment={projectAndIssue[1]}
            fileDTOList={[
              {
                id: 14053,
                title: "Test",
                mineType: "application/pdf",
                name: "PassageAnswer.pdf",
                s3Url:
                  "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1718173206294-PassageAnswer.pdf",
                s3FileName: null
              }
            ]}
          />
        ))}
      </>
      // <React.Fragment>
      //   <DisplayByPermission display={displayPopUp}>
      //     <AddDecision
      //       show={displayPopUp}
      //       redirectToAgenda={this.redirectToAgenda}
      //       handleClose={this.onToggleModal}
      //       issues={issues}
      //       project={project}
      //       meetingData={showMeetingData}
      //       agendaData={agendaData}
      //       viewMoreStatus={viewMoreStatus}
      //       handleUpdateStatus={handleUpdateStatus}
      //       title={
      //         !showMeetingData ||
      //         get(showMeetingData, "decisionStatus") === DRAFT
      //           ? "Add"
      //           : "Edit"
      //       }
      //     />
      //   </DisplayByPermission>
      //   <div className="project-issues-pragatidetail">
      //   <div
      //     className="project-list-box-wrapper pragati-project-list-box-wrapper"
      //     data-test="project-list-wrapper"
      //   >
      //     <div class="pragati-select-issue-wrapper agenda-project-wrapper">

      //       <div class="pragati-project-container">
      //         <div className="project-list-box-top" style={{borderBottom:0,paddingBottom:0}}>
      //           <div className="project-box-top-upper" style={{marginBottom:0}}>
      //             <div className="pragati-project-name-section">
      //               <div className="d-flex flex-wrap">
      //                 {/* <div>
      //                   {iigProjectCommonId && (
      //                     <div className="id-wrapper-box mr-2">
      //                       <p className="border-right mb-1 common-project-id">
      //                         COMMON PROJECT ID{" "}
      //                        <b className="link-color mr-2 iig-project-link-color">
      //                           {this.openProjectPageBasedOnCommonLink()}
      //                         </b>
      //                       </p>
      //                     </div>
      //                   )}
      //                 </div> */}
      //                 <div className="project-id mb-1">
      //                   Project{" "}
      //                   <b>
      //               <Link
      //                 to={{
      //                   pathname: PATHS.PROJECT_DETAILS,
      //                   search: `?issueId=${get(issues, "id")}&&projectId=${get(
      //                     projectDetail,
      //                     "id"
      //                   )}`
      //                 }}
      //               >
      //                 #PMG-
      //                 {get(projectDetail, "id", null)}
      //               </Link>
      //             </b>
      //                   {/* <b data-test="project-id">
      //                     {this.openProjectPageBasedOnLink()}
      //                   </b> */}
      //                 </div>

      //                 {projectPPList &&
      //                   projectPPList.map(item => {
      //                     if (item !== null) {
      //                       if (item.organizationGroup !== null) {
      //                         return (
      //                           <OrganizationTemplate
      //                             title={item.organizationGroup}
      //                             classes="pragati-page-organisation mb-2 g"
      //                           />
      //                         );
      //                       }
      //                     }
      //                   })}
      //                   <span class="pragati-page-verified mb-2 g">verified</span>
      //                 {/* <div className="project-stage-section">
      //                   <div
      //                     className={`${getBackgroundColorCode(
      //                       status
      //                     )} project-stage-background`}
      //                   >
      //                     <span
      //                       className={`project-stage`}
      //                       data-test="project-stage"
      //                     >
      //                       {status}
      //                     </span>
      //                   </div>
      //                   {get(project, "terminatedDate", null) ? (
      //                     <div className="date-terminated">
      //                       <Image src={IconTime} alt="Time" />
      //                       <span>
      //                         {dateFormat(get(project, "terminatedDate", null))}
      //                       </span>
      //                     </div>
      //                   ) : null}
      //                   {isResolved ? (
      //                     <div className="resolution-date">
      //                       <div> Resolved on</div>
      //                       <div className="second-row">
      //                         <Image src={IconTime} alt="Time" />
      //                         <span>{projectResolutionDate}</span>
      //                       </div>
      //                     </div>
      //                   ) : null}
      //                 </div> */}
      //               </div>
      //               <Link
      //                 to={{
      //                   pathname: PATHS.PROJECT_DETAILS,
      //                   search: `?issueId=${get(issues, "id")}&&projectId=${get(
      //                     projectDetail,
      //                     "id"
      //                   )}`
      //                 }}
      //               ><h2 className="pragati-project-heading">{get(projectDetail, "name", null)}</h2></Link>
      //               {/* <h2 className="project-name" data-test="project name">
      //                 {this.openProjectPageBasedOnLink(true)}
      //               </h2> */}
      //               {get(projectDetail, "projectStatusWithRespectToIssueStatus") ||
      //               get(projectDetail, "projectCompletionDTO.status") ? (
      //                 <div className="project-status">
      //                   {get(
      //                     projectDetail,
      //                     "projectStatusWithRespectToIssueStatus"
      //                   ) &&
      //                   get(
      //                     projectDetail,
      //                     "projectStatusWithRespectToIssueStatus"
      //                   ) !== "NO ISSUES" ? (
      //                     <></>
      //                     // <span
      //                     // /**className={getColorCode(
      //                     //                                                                                                   get(project, "projectStatusWithRespectToIssueStatus")
      //                     //                                                                                                 )} */
      //                     // >
      //                     //   {get(
      //                     //     projectDetail,
      //                     //     "projectStatusWithRespectToIssueStatus"
      //                     //   )}
      //                     // </span>
      //                   ) : null}
      //                   {get(projectDetail, "projectCompletionDTO.status") &&
      //                   get(projectDetail, "projectCompletionDTO.status") !==
      //                     "NO IMPLEMENTATION" ? (
      //                     <span
      //                   className="pragati-page-status"
      //                     >
      //                       {get(projectDetail, "projectCompletionDTO.status")}
      //                     </span>
      //                   ) : null}
      //                 </div>
      //               ) : null}
      //             </div>
      //           </div>
      //           <div className="project-box-top-lower">
      //             <div className="project-details-left-section">
      //               <div className="pragati-project-detail-unit display-mobile">
      //                 {/* <div className="heading-text">Project Id - </div> */}
      //                 {/* <b>{this.openProjectPageBasedOnLink()}</b> */}
      //               </div>
      //               {/* {organistionArr && organistionArr.length ? (
      //                 <div className="pragati-project-detail-unit display-mobile">
      //                   <div className="heading-text">pragati-page-organisation:</div>
      //                   <div>
      //                     {organistionArr.map((item, index) => (
      //                       <span>
      //                         {item.organizationGroup}
      //                         {index < organistionArr.length - 1
      //                           ? ", "
      //                           : ""}{" "}
      //                       </span>
      //                     ))}
      //                   </div>
      //                 </div>
      //               ) : null} */}
      //               <div className="pragati-project-detail-unit">
      //                 <div className="heading-text">Sponsoring Ministry -{" "}</div>
      //                 <span style={{color:"#000",fontFamily:"mpsb",marginLeft:4}}> {get(projectDetail, "sponsoredBy")}</span>
      //               </div>
      //               {get(projectDetail, "sponsoringDepartment") ? (
      //                 <div className="pragati-project-detail-unit">
      //                   <div className="heading-text">
      //                     {projectFormLabel(
      //                       get(projectDetail, "sponsoredByid"),
      //                       "department",
      //                       "Sponsoring Department"
      //                     )}
      //                     -{" "}
      //                   </div>
      //                   <span style={{color:"#000",fontFamily:"mpsb",marginLeft:4}}> {get(projectDetail, "sponsoringDepartment.name")}</span>
      //                 </div>
      //               ) : null}
      //               {isValidArray(get(projectDetail, "locations")) ? (
      //                 <div className="pragati-project-detail-unit">
      //                   <div className="heading-text">Project Location - </div>
      //                   <ReadMore
      //                     content={<span style={{color:"#000",fontFamily:"mpsb",marginLeft:4}}> {projectLocations}</span>}
      //                     clamp={3}
      //                     displayExpandButtons={false}
      //                   />
      //                 </div>
      //               ) : null}
      //               {/* {get(project, "implMode") ? (
      //             <div className="pragati-project-detail-unit">
      //               <div className="heading-text">Implementation Mode:</div>
      //               <span>{get(project, "implMode", "NA")}</span>
      //             </div>
      //           ) : null} */}
      //               <div className="project-issues-details" style={{fontSize:14}}>
      //                 Issue(s) Open -{" "}
      //                 <span style={{color:"#000",fontFamily:"mpsb"}}>{get(projectDetail, "openIssuesCount", 0)}</span> |
      //                 Issue(s) Resolved -{" "}
      //                 <span style={{color:"#000",fontFamily:"mpsb"}}>{get(projectDetail, "resolvedIssuesCount", 0)}</span>
      //               </div>

      //               {/* <div className="project-issues-details space-border-left">

      //               </div> */}

      //               {get(projectDetail, "projectCompletionDTO") &&
      //               get(projectDetail, "projectCompletionDTO.percentage") ? (
      //                 <div className="physical-progress-wrapper">
      //                   <div className="progress-upper d-flex align-items-center fw-bold" style={{marginTop:5,fontSize:14}}>
      //                     Physical Progress -{" "}
      //                     <span className="d-inline-block">
      //                       {get(projectDetail, "projectCompletionDTO.percentage")}%
      //                     </span>
      //                   </div>
      //                   {get(
      //                     projectDetail,
      //                     "projectCompletionDTO.physicalProgressAsOf"
      //                   ) ? (
      //                     <div className="progress-lower">
      //                       (as of{" "}
      //                       {dateFormat(
      //                         get(
      //                           projectDetail,
      //                           "projectCompletionDTO.physicalProgressAsOf"
      //                         )
      //                       )}
      //                       )
      //                     </div>
      //                   ) : get(projectDetail, "projectCompletionDTO.date") ? (
      //                     <div className="progress-lower">
      //                       (as of{" "}
      //                       {dateFormat(
      //                         get(projectDetail, "projectCompletionDTO.date")
      //                       )}
      //                       )
      //                     </div>
      //                   ) : null}
      //                 </div>
      //               ) : null}
      //             </div>
      //             <div className="project-details-right-section">
      //               {/* <div className="project-impl-mode">
      //                                 Impl. Mode - {get(project, "implMode", "NA")}
      //                             </div> */}
      //               <div className="project-list-box-bottom">
      //                 <div className="project-bottom-left">
      //                   <div className="d-flex tags-contatiner" style={{float:"right",marginRight:"-3%"}}>
      //                     <Pragati
      //                       className={"pragati-review-detail-page"}
      //                       isValidProject={get(
      //                         projectDetail,
      //                         "pragatiDTO.pragatiReview"
      //                       )}
      //                     />
      //                     <Nip
      //                       className={"pragati-review-detail-page"}
      //                       isValidProject={get(projectDetail, "nipDTO.nipReview")}
      //                     />
      //                     <PmFoundationStone
      //                       className={"pragati-review-detail-page"}
      //                       isValidProject={get(
      //                         projectDetail,
      //                         "pmFoundationStoneDTO.pmFoundationStone"
      //                       )}
      //                     />
      //                     <PmGatiShakti
      //                       className={"pragati-review-detail-page"}
      //                       isValidProject={get(
      //                         projectDetail,
      //                         "pmGatiShaktiDTO.pmGatiShakti"
      //                       )}
      //                     />
      //                     <Pli
      //                       className={"pragati-review-detail-page"}
      //                       isValidProject={get(projectDetail, "pliDTO.pli")}
      //                     />
      //                     <March24
      //                       className={"pragati-review-detail-page"}
      //                       isValidProject={get(projectDetail, "march24DTO.march24")}
      //                     />
      //                   </div>
      //                 </div>
      //               </div>
      //               <div className="pragati-project-cost-section">
      //                 <label>Project Cost</label>
      //                 <p className="pragati-page-cost">
      //                   {parseFloat(projectCost) !== 0
      //                     ? `₹ ${projectCost} Cr.`
      //                     : "N/A"}
      //                 </p>
      //               </div>
      //               <div className="project-created-date">
      //                 <span
      //                   className={`project-created-by
      //                                   ${
      //                                     createdBy && createdBy.verified
      //                                       ? "verified-user"
      //                                       : ""
      //                                   }
      //                                   `}
      //                 />
      //                 <span className="first-pp-name">
      //                   <RedirectUser
      //                     title={get(createdBy, "name", null)}
      //                     id={get(createdBy, "id", null)}
      //                     isProjectProponentDetail={true}
      //                     data-test="first-pp-name"
      //                   />
      //                 </span>
      //                 {projectPPList && projectPPList.length > 1 ? (
      //                   <div
      //                     className={`dropdown field-sort ${
      //                       showOtherPPList ? "visible" : ""
      //                     }`}
      //                     onClick={this.toggleOtherPPList}
      //                   >
      //                     <div
      //                       className={`dropdown-overlay ${
      //                         showOtherPPList ? "visible" : ""
      //                       }`}
      //                     />
      //                     <div className="dropdown-selected-value">
      //                       + {projectPPList.length - 1}
      //                     </div>
      //                     <div className="dropdown-option-list hidden-mobile">
      //                       <div className="dropdown-option-list-heading" />
      //                       {projectPPList
      //                         ? projectPPList.map((value, index) => {
      //                             if (index !== 0) {
      //                               return (
      //                                 <RedirectUser
      //                                   title={get(value, "name", null)}
      //                                   id={get(value, "id", null)}
      //                                   isProjectProponentDetail={true}
      //                                 />
      //                               );
      //                             }
      //                           })
      //                         : null}
      //                     </div>
      //                   </div>
      //                 ) : null}
      //                 <span className="project-created-on">
      //                   {get(projectDetail, "verificationDate")
      //                     ? `Verified on ${dateFormat(
      //                         get(projectDetail, "verificationDate", null)
      //                       )}`
      //                     : `${isIIGDraft ? "Created on" : "Created on"}
      //                   ${dateFormat(get(projectDetail, "createdDate", null))}`}
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     </div>

      //     {/* {project.issuesSelected.map((item, index) => (
      //       <>
      //         <IssueSingle
      //           issue={item}
      //           idx={item.id}
      //           key={index}
      //           deleteHandler={this.deleteSingleIssueHandler}
      //           fromCreateAgendaPage={true}
      //           IssueSelected="delete"
      //         />
      //       </>
      //     ))} */}
      //   </div>
      //   <div className="select-issue-wrapper-pragati">

      //     <div className="select-issue-content" style={{width:"-webkit-fill-available"}}>
      //       <div className="issue-list-top">
      //         <div className="issue-list-header">
      //           <span
      //             className={`issue-number ${
      //               get(issues, "duplicate") ? "duplicate-issue-number" : ""
      //             }`}
      //           >
      //             {get(issues, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
      //             <b>
      //               <Link
      //                 to={{
      //                   pathname: PATHS.ISSUE_DETAIL,
      //                   search: `?issueId=${get(issues, "id")}&&projectId=${get(
      //                     issues,
      //                     "projectId"
      //                   )}`
      //                 }}
      //               >
      //                 #{get(issues, "displayId", null)}-
      //                 {get(issues, "id", null)}
      //               </Link>
      //             </b>
      //             <Button
      //             className={`btn-extra-small animated flipInX pragatibtn ${getColor(
      //               get(issues, "status", "NA").toLowerCase()
      //             )} unClickable`}
      //           >
      //             {get(issues, "status", "NA")}
      //           </Button>
      //           </span>
      //           <h2 className="issue-title">{get(issues, "title", null)}</h2>
      //          <div>

      //          </div>
      //         </div>
      //         {/* <div className="issue-list-status">
      //            <div className="issue-list-status-inner">
      //             <div className="issue-assignee">
      //               {get(issues, "status") === ISSUE_STATUS.REJECT ||
      //               get(issues, "status") === ISSUE_STATUS.RESOLVED ||
      //               get(issues, "status") === ISSUE_STATUS.REJECTED ||
      //               get(issues, "status") === ISSUE_STATUS.HOLD ||
      //               get(issues, "status") === ISSUE_STATUS.reject ||
      //               get(issues, "status") === ISSUE_STATUS.resolved ||
      //               get(issues, "status") === ISSUE_STATUS.hold ||
      //               get(issues, "status") === ISSUE_STATUS["On Hold"] ? (
      //                 get(issues, "status") === ISSUE_STATUS.REJECT ||
      //                 get(issues, "status") === ISSUE_STATUS.reject ||
      //                 get(issues, "status") === ISSUE_STATUS.REJECTED ? (
      //                   <>
      //                     <span className="issue-assignee-title">
      //                       Rejected by{" "}
      //                     </span>
      //                     <b>{get(issues, "issueStatusChangeGroup")}</b>
      //                   </>
      //                 ) : get(issues, "status") === ISSUE_STATUS.RESOLVED ||
      //                   get(issues, "status") === ISSUE_STATUS.resolved ? (
      //                   <>
      //                     <span className="issue-assignee-title">
      //                       Resolved by{" "}
      //                     </span>
      //                     <b>{get(issues, "issueStatusChangeGroup")}</b>
      //                   </>
      //                 ) : (
      //                   <>
      //                     <span className="issue-assignee-title">
      //                       On Hold by{" "}
      //                     </span>
      //                     <b> {get(issues, "issueStatusChangeGroup")}</b>
      //                   </>
      //                 )
      //               ) : (
      //                 <>
      //                   <span className="issue-assignee-title">
      //                     Assigned to{" "}
      //                   </span>
      //                   <b>{get(issues, "assigneeGroup")}</b>
      //                 </>
      //               )}
      //             </div>
      //             <div className="issue-assign-date">
      //               <Image src={IconTime} alt="Time" />
      //               <span>
      //                 {get(issues, "status") === ISSUE_STATUS.REJECT ||
      //                 get(issues, "status") === ISSUE_STATUS.RESOLVED ||
      //                 get(issues, "status") === ISSUE_STATUS.HOLD ||
      //                 get(issues, "status") === ISSUE_STATUS.reject ||
      //                 get(issues, "status") === ISSUE_STATUS.resolved ||
      //                 get(issues, "status") === ISSUE_STATUS.REJECTED ||
      //                 get(issues, "status") === ISSUE_STATUS.hold ||
      //                 get(issues, "status") === ISSUE_STATUS["On Hold"]
      //                   ? `on ${dateFormat(
      //                       get(issues, "issueStatusChangeDate")
      //                     )}`
      //                   : get(issues, "status") ===
      //                       ISSUE_STATUS["Pending with RM/RS"] ||
      //                     get(issues, "status") ===
      //                       ISSUE_STATUS["Pending with PMG"] ||
      //                     get(issues, "status") ===
      //                       ISSUE_STATUS["Pending with SM"]
      //                   ? `on ${dayAgo(get(issues, "issueStatusChangeDate")) ||
      //                       "NA"}`
      //                   : get(issues, "lastAssigneeDate")
      //                   ? dayAgo(get(issues, "lastAssigneeDate"))
      //                   : dayAgo(get(issues, "createdDate"))}
      //               </span>
      //             </div>
      //           </div>

      //         </div> */}
      //       </div>
      //       <div className="issue-list-middle" style={{lineHeight:"20px"}}>
      //         <div className="issue-list-desc-wrapper">
      //           <span className="issue-recipient">
      //             <span className="issue-recipient-title">
      //               Recipient{" "}
      //               {transformProjectCategoryId(
      //                 get(issues, "recipientGroupCategory")
      //               )}{" "}
      //               -{" "}
      //             </span>
      //             {get(issues, "recipientState", "NA")}
      //           </span>
      //           {get(issues, "districtName") ? (
      //             <span className="issue-recipient">
      //               <span className="issue-recipient-title">
      //                 District/Department -{" "}
      //               </span>
      //               {get(issues, "districtName")}
      //             </span>
      //           ) : null}
      //           <p className="issue-category to-n-fro" style={{marginBottom:0,marginTop:0}}>
      //             <span className="slide-issue">
      //               <span className="issue-category-title">
      //                 Issue Category -{" "}
      //               </span>
      //               {get(issues, "category", null)}
      //             </span>
      //             <span className="clowdy" />
      //           </p>
      //           {get(issues, "subCategory") ? (
      //             <p className="issue-sub-category to-n-fro">
      //               <span className="slide-issue">
      //                 <span className="issue-category-title">
      //                   Issue Sub-Category -{" "}
      //                 </span>
      //                 {get(issues, "subCategory", null)}
      //               </span>
      //               <span className="clowdy" />
      //             </p>
      //           ) : null}
      //           {/* {get(issues, "proposalNoParivesh") ? (
      //             <p className="issue-sub-category">
      //               <span className="issue-category-title">
      //                 Proposal No. (Parivesh) -{" "}
      //               </span>
      //               {get(issues, "proposalNoParivesh", "NA")}
      //             </p>
      //           ) : null}
      //           <div className="issue-list-desc">
      //             <ReadMore content={get(issues, "description", "NA")} />
      //           </div> */}
      //           {/* {(get(issues, "latestIssueComments") && (
      //             <div>
      //               <div className="decision-heading decision-heading-margin">
      //                 <h3>Latest Comment</h3>
      //               </div>
      //               <DisplayContent
      //                 classes={"issue-list-desc"}
      //                 content={get(issues, "latestIssueComments")}
      //               />
      //             </div>
      //           )) ||
      //             null} */}

      //           {/* {(get(issues, "meetingDecisionDTOS", []).length && (
      //             <div className="decision-heading">
      //               <h3>Last Decision</h3>
      //               <span onClick={this.handleViewMore}>
      //                 View{" "}
      //                 {showMeetingData
      //                   ? get(issues, "meetingDecisionDTOS", []).length - 1
      //                   : get(issues, "meetingDecisionDTOS", []).length}{" "}
      //                 more decision
      //               </span>
      //             </div>
      //           )) ||
      //             null}
      //           {get(showMeetingData, "meetingId") ? (
      //             <MOMDesc issues={issues} meeting={showMeetingData} />
      //           ) : null} */}
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      //   </div>
      //   <DisplayByPermission display={issueAction && displayActions}>
      //     <div className="issue-actions issue-list-action issue-action-single-list">
      //       <IssueActions
      //         isLoading={isActionLoading}
      //         issueDetails={{ ...issues, ...actionsData }}
      //         callApiOnSuccess={this.callApiOnSuccess}
      //       />
      //     </div>
      //   </DisplayByPermission>
      // </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueListReducer: state.issueListReducer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getActions,
      _getIssueList,
      getMomDetails
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IssueSingleList)
);
